
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/content_wall/templates/moment_empty_content_wall"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='posts_container'><div class='end_of_content_title'>No content to show</div></div>\n";
},"useData":true});
    }).call(this);
  